import { z } from "zod";
import { RequestStateTypeEnumSchema } from "@/Enums/RequestStateTypeEnum";

export const GetRequestStateDtoSchema = z.object({
    requestId: z.string(),
    isSubmitted: z.boolean(),
    requestStateTypeId: RequestStateTypeEnumSchema.nullable(),
});

export type GetRequestStateDto = z.infer<typeof GetRequestStateDtoSchema>;
